<template>
  <div
    class="kiosk-view bg-white pt-0 px-0 pt-lg-3 px-lg-5 text-text-color-dark"
  >
    <CContainer>
      <CRow class="justify-content-center mt-0 mt-lg-4">
        <CCol md="8" class="text-center">
          <h1 class="text-center mb-4">
            Kiosk
            <HelpCenterButton
              classes="me-2"
              content-key="form_location_kiosk"
            />
          </h1>
          <span
            class="d-block rounded-pill w-100 text-center p-2 my-3"
            id="kiosk-view-text"
          >
            Choose the FROM location for your Kiosk below. "Me" will display
            your name as the FROM location.
          </span>
          <div class="max-w-400 m-auto">
            <CreateKioskForm />
          </div>
        </CCol>
      </CRow>
    </CContainer>
    <KioskDataTable ref="AptPassDataTable" />
  </div>
</template>
<script>
import KioskDataTable from "@/components/DataTables/KioskDataTable"
import CreateKioskForm from "../components/Forms/CreateKioskForm"
import HelpCenterButton from "@/components/HelpCenterButton"

export default {
  name: "Kiosks",
  components: { KioskDataTable, CreateKioskForm, HelpCenterButton }
}
</script>
